import React from 'react';

class StaticCheckboxFormType extends React.Component {
    render() {
        return (
            <div>
                <div className="col-dt-50 col-tbl-full">
                    <StaticCheckboxList elements={this.props.types} onOptionalAttributeChanged={(name, state) => this.props.onOptionalAttributeChanged(name, state)} checkedAttributes={this.props.checkedAttributes}/>
                </div>
                <div className="col-dt-50 col-tbl-full">

                </div>
            </div>
        );
    }
}

class StaticCheckboxList extends React.Component {
    render() {
        const _this = this;

        var radioElements = this.props.elements.map(function(element) {

            var checked = false;

            if(_this.props.checkedAttributes !== null && element.input_name in _this.props.checkedAttributes){
                checked = true;
            }
            return (
                <StaticCheckboxElement key={element.input_name + element.value} input_name={element.input_name} value={element.value} checked={checked} name={element.name} onOptionalAttributeChanged={(name, state) => _this.props.onOptionalAttributeChanged(name, state)} />
            );
        });
        return (
            <div className="neutrik-radio">
                {radioElements}
            </div>
        );
    }
}

class StaticCheckboxElement extends React.Component {

    onValueChanged(e) {

        if(e.target.checked){
            this.props.onOptionalAttributeChanged(this.props.input_name, this.props.value);
        }else {
            this.props.onOptionalAttributeChanged(this.props.input_name, null);
        }
    }

    render() {
        return (
            <div className="neutrik-radio">
                <input type="checkbox" name={this.props.input_name} value={this.props.value} id={this.props.input_name} onChange={(e) => this.onValueChanged(e)} checked={this.props.checked}/>
                <label htmlFor={this.props.input_name}>{this.props.name}</label>
            </div>
        );
    }
}

export default StaticCheckboxFormType;


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/components/StaticCheckboxFormType.js